<template lang="html">
  <div v-if="getLoadingAxiosState || getLoadingState">
    <div class="_loading-overflow" />
    <div class="_loading-content">
      <div class="_loading-wrap">
        <lottie :options="defaultOptions" style="transform: scale(2);" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Lottie from 'vue-lottie'
import loading from '@/assets/json/loading.json'
export default {
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: {
        animationData: loading
      }
    }
  },
  computed: {
    ...mapGetters(['getLoadingAxiosState', 'getLoadingState'])
  }
}
</script>
